<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Edit Profile</h4>
        <p class="category">Complete or edit your profile</p>
      </md-card-header>

      <md-card-content>
        <div v-if="updated">
          <p class="text-primary">Profile updated.</p>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>First Name</label>
              <md-input v-model="form.first_name" type="text"></md-input>
              <span class="md-error" v-if="hasValidationError('first_name')">{{ getValidationError("first_name") }}</span>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Last Name</label>
              <md-input v-model="form.last_name" type="text"></md-input>
              <span class="md-error" v-if="hasValidationError('last_name')">{{
                getValidationError("last_name")
              }}</span>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email</label>
              <md-input v-model="form.email" type="text"></md-input>
              <span class="md-error" v-if="hasValidationError('email')">{{
                getValidationError("email")
              }}</span>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Phone number</label>
              <md-input v-model="form.phone" type="text"></md-input>
              <span class="md-error" v-if="hasValidationError('phone')">{{
                getValidationError("phone")
              }}</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button @click.prevent="updateProfile" class="md-raised md-primary">Update Profile</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import axios from "@/axios";

export default {
  name: "edit-profile-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      updated: false,
      form: {
        first_name: store.getters.user.firstname,
        last_name: store.getters.user.lastname,
        email: store.getters.user.email,
        phone: store.getters.user.phone,
      }
    };
  },
  methods: {
    updateProfile() {
      axios
        .put("/user", this.form)
        .then(response => {
          store.commit("setUserInfo", response.data.user);
          this.updated = true;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  computed: {
    ...mapGetters(["hasValidationError", "getValidationError"]),
    user() {
      return store.getters.user;
    }
  },
  watch: {
    user(newUser) {
      this.form.first_name = newUser.firstname;
      this.form.last_name = newUser.lastname;
      this.form.email = newUser.email;
      this.form.phone = newUser.phone;
    }
  }
};
</script>
<style></style>
